import { UIViewSpec } from './view';
import { xavis_experiments } from '../y/debug';

declare global {
    interface Element {
        ui_src_transition?: string;
        ui_dst_transition?: string;
    }
}

export function uiSetTransition(name: string, view: UIViewSpec, mode?: 'src' | 'dst' | 'both') {
    if(!xavis_experiments) return;

    const elem = view.ui_elem;
    if(mode != 'dst') {
        elem.classList.add('x-transition-src');
        elem.ui_src_transition = name;
    }
    if(mode != 'src') {
        elem.classList.add('x-transition-dst');
        elem.ui_dst_transition = name;
    }
}

function uiGetTransitions(where: UIViewSpec, mode: 'src' | 'dst') {
    const cls = 'x-transition-' + mode;
    const prop = mode == 'src' ? 'ui_src_transition' : 'ui_dst_transition';

    const transitions: Record<string, Element> = {};
    for(const e of where.ui_elem.getElementsByClassName(cls)) {
        transitions[e[prop]!] ??= e;
    }

    return transitions;
}

export function uiSetupTransition(where: UIViewSpec[], mode: 'src' | 'dst') {
    let view_map: Record<string, HTMLElement> = {};

    for(const w of where) {
        Object.assign(view_map, uiGetTransitions(w, mode));
    }

    for(const n in view_map) {
        view_map[n].style.viewTransitionName = n;
    }

    return view_map;
}

export function uiCleanupTransition(view_map?: Record<string, HTMLElement>) {
    for(const n in view_map) {
        view_map[n].style.viewTransitionName = '';
    }
}
